import { usd } from "./helpers";

interface PayoutSummaryProps {
  vendorCommission: number;
  tips: number;
  salesTax: number;
  salesTaxResponsible: boolean;
  totalDeductions: number;
  totalAdjustments: number;
  participationFee: number;
  totalDue: number;
}

export const PayoutSummary = ({
  vendorCommission,
  tips,
  salesTax,
  salesTaxResponsible,
  totalDeductions,
  totalAdjustments,
  participationFee,
  totalDue,
}: PayoutSummaryProps) => (
  <div className="space-y-1 text-sm">
    <Row label="Vendor Commission" value={usd(vendorCommission)} />
    {tips > 0 && <Row label="Tips" value={usd(tips)} />}
    {salesTaxResponsible && salesTax > 0 && (
      <Row label="Sales Tax (vendor remits)" value={usd(salesTax)} />
    )}
    {totalAdjustments > 0 && (
      <Row label="Adjustments" value={usd(totalAdjustments)} />
    )}
    {totalDeductions > 0 && (
      <Row label="Less: Deductions" value={`(${usd(totalDeductions)})`} red />
    )}
    {participationFee > 0 && (
      <Row label="Less: Participation Fee" value={`(${usd(participationFee)})`} red />
    )}
    <div className="border-t-2 border-gray-400 pt-2 mt-2">
      <div className="flex justify-between">
        <span className="text-base font-bold text-gray-900">Total Due Vendor</span>
        <span className={`text-base font-bold tabular-nums ${totalDue >= 0 ? "text-green-700" : "text-red-700"}`}>
          {totalDue < 0 ? `-${usd(Math.abs(totalDue))}` : usd(totalDue)}
        </span>
      </div>
    </div>
  </div>
);

const Row = ({
  label,
  value,
  red,
}: {
  label: string;
  value: string;
  red?: boolean;
}) => (
  <div className="flex justify-between py-0.5">
    <span className="text-gray-600">{label}</span>
    <span className={`tabular-nums ${red ? "text-red-700" : "text-gray-900"}`}>
      {value}
    </span>
  </div>
);
